<template>
	<transition name="slide-fade">
		<div
			v-if="visible"
			class="app-modal"
			@click.self="close"
		>
			<div class="app-modal__content">
				<slot></slot>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	props: {
		visible: Boolean
	},

	methods: {
		close () {
			if (this.$listeners.close) this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
.app-modal {
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background-color: #00000029;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
	overflow: auto;

	&__content {
        border-radius: 5px;
		box-shadow: 0 1px 6px #00000029;
		background-color: #fff;
	}
}

.slide-fade-enter-active,
.slide-fade-leave-active {
	transition: all .5s ease;
	opacity: 1;
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(-10px);
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppModal.vue